import { z } from "zod";

export const ID_PREFIXES = {
  access: ["usr", "inv", "mcr", "adm"],
  profiles: ["prf", "org", "aff", "prs", "sug", "pln", "plr", "rck", "mrg", "rfp", "rsg"],
  collection: ["src", "scn", "gap", "brk", "itm", "ver", "art", "man", "att", "rgt", "rte", "bfl", "ext", "pwi"],
  transcription: ["trj", "res", "spk", "idn", "nmd", "pmd", "chk"],
  evidence: ["com", "rev", "unt", "asg", "cpy", "aln", "cor", "cov", "rpt", "ass", "lse", "pol", "spl", "ock"],
  operations: ["cst", "tsk", "pau", "job", "bud", "rvs", "bvr", "drl", "dep"],
  platform: ["aud"],
} as const;

export type IdPrefix = (typeof ID_PREFIXES)[keyof typeof ID_PREFIXES][number];

export const ALL_ID_PREFIXES: readonly IdPrefix[] = Object.values(ID_PREFIXES).flat();

const ULID = "[0-9A-HJKMNP-TV-Z]{26}";

export const ANY_ID_PATTERN = new RegExp(`^(${ALL_ID_PREFIXES.join("|")})_${ULID}$`);

export function idSchema<P extends IdPrefix>(prefix: P) {
  return z
    .string()
    .regex(new RegExp(`^${prefix}_${ULID}$`), `expected a ${prefix}_ identifier`)
    .brand<`${P}Id`>();
}

export type Id<P extends IdPrefix> = z.infer<ReturnType<typeof idSchema<P>>>;

export const anyIdSchema = z.string().regex(ANY_ID_PATTERN, "expected an Amber identifier");
